export default {
      id: "i-triangle-black-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/sprite.svg#i-triangle-black",
      toString: function () {
        return this.url;
      }
    }